import { render, staticRenderFns } from "./CampaignDetailPage.vue?vue&type=template&id=5204e484&"
import script from "./CampaignDetailPage.vue?vue&type=script&lang=js&"
export * from "./CampaignDetailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports